export default __webpack_public_path__ + "static/media/logo-agent-assure-condensed.2f885fda.svg";